import React from 'react';

import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
} from 'nav/expanded/ListingRendererConstants';
import {SortKey} from 'search/SearchConstants';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {DatetimeTableCell} from 'ui-library/scrollable/table-cells/DatetimeTableCell';
import {BasicEvent} from 'util/Types';

import {PredictionBatchListingGraphQL} from '../../../graphql-fragments/model-hub/__generated/PredictionBatchListingGraphQL';

export default class PredictionBatchListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.PREDICTION_BATCH> {
  listingRendererType = ListingRendererType.PREDICTION_BATCH;

  renderIcon(): JSX.Element {
    return <BenchlingIcon icon="microscope" className="scrollableTable-cell-icon" />;
  }

  getNonPluginColumnConfigurations(
    items: Array<PredictionBatchListingGraphQL>
  ): Array<ColumnConfiguration<PredictionBatchListingGraphQL>> {
    const columns: Array<ColumnConfiguration<PredictionBatchListingGraphQL>> = [
      {
        column: {
          accessorKey: ColumnAccessorKey.NAME,
          header: 'Name',
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_NAME_KEY,
        },
        render: (predictionBatch: PredictionBatchListingGraphQL) => predictionBatch.name,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.CREATED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_CREATED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_CREATED_AT_KEY,
        },
        render: (predictionBatch: PredictionBatchListingGraphQL) => (
          <DatetimeTableCell datetime={predictionBatch.createdAt} showTimeInCell={false} />
        ),
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.MODIFIED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_MODIFIED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_MODIFIED_AT_KEY,
        },
        render: (predictionBatch: PredictionBatchListingGraphQL) => (
          <DatetimeTableCell datetime={predictionBatch.modifiedAt} showTimeInCell={false} />
        ),
      },
    ];

    return columns;
  }

  getNonPluginRowContentHeight(item: PredictionBatchListingGraphQL): number {
    return 40;
  }

  openContextMenu(item: PredictionBatchListingGraphQL, e: BasicEvent, extras: unknown): void {
    // Context menu not yet implemented for prediction batches
  }
}
